<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-14 16:48:36
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-09-15 16:24:55
 * @name: 表格
 * @Description: 表格 
 * @FilePath: \preSaleNafterSaleBackstage\src\components\public\table-normal.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="table">
    <!-- 标题 -->
    <slot name="title" />
    <!-- 头部按钮 -->
    <slot name="head" />
    <!-- bar条 -->
    <slot name="bar" />
    <!-- 表格 -->
    <slot name="table" />
    <!-- 分页器区域 -->
    <slot name="pagination" />
  </div>
</template>
<script>
export default {
  name: "tableNormal",
};
</script>
<style lang="scss" scoped>
.table {
  @extend .extend-table;
  @extend .extend-flex-column-normal;
  .title {
    @extend .extend-table-title;
  }
  .head {
    @extend .extend-table-head;
  }
  .bar {
    @extend .extend-table-bar;
  }
  .pagination {
    @extend .extend-pagination;
  }
}
</style>